import { AxiosResponse } from 'axios';
import HttpStatus from 'model/enums/httpStatus';
import { ShareholderToGetAllByPersonId } from 'model/shareholder.model';
import { markError } from 'reducer/application/error/actions';
import { shareholderGetAllByPersonIdError, shareholderGetAllByPersonIdSuccess, shareholderGetAllByPersonIdRequest } from 'reducer/shareholder/get-all-by-person-id/actions';
import { ShareholderGetAllByPersonIdActionTypes } from 'reducer/shareholder/get-all-by-person-id/types';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import shareholderApi from 'services/api/shareholder-api';
import { ErrorUtils } from 'shared/error/error-utils';

function* handleShareholderGetALlByPersonIdProfile(action: ReturnType<typeof shareholderGetAllByPersonIdRequest>) {
    try {
        const result: AxiosResponse<ReadonlyArray<ShareholderToGetAllByPersonId>> = yield call(shareholderApi.getAllBypersonId, action.payload);
        if (result.status !== HttpStatus.OK) {
            const mapped = ErrorUtils.mapGiroIdhApiError(result);
            yield put(markError(mapped));
            yield put(shareholderGetAllByPersonIdError(mapped));
            return;
        }
        yield put(shareholderGetAllByPersonIdSuccess(result.data));
    } catch (error) {
        const mapped = ErrorUtils.mapLocalError(error);
        yield put(markError(mapped));
        yield put(shareholderGetAllByPersonIdError(mapped));
    }
}

function* watchShareholderGetALlByPersonIdRequest() {
    yield takeEvery(ShareholderGetAllByPersonIdActionTypes.SHAREHOLDER_GET_ALL_BY_PERSON_ID_REQUEST, handleShareholderGetALlByPersonIdProfile);
}

function* shareholderGetAllByPersonIdSagas() {
    yield all([fork(watchShareholderGetALlByPersonIdRequest)]);
}

export default shareholderGetAllByPersonIdSagas;
